<template>
  <div
    class="drop-down"
    :class="{ 'drop-down--active': showingMenu }"
    v-click-outside="onClickOutside"
  >
    <slot name="activator">
      <app-button
        @click.native="toggleMenu"
        class="drop-down__activator"
        size="sm"
        variant="text"
      >
        <font-awesome-icon icon="ellipsis-h" />
      </app-button>
    </slot>
    <transition name="slide-fade">
      <div class="drop-down__menu" v-show="showingMenu">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside-x';

export default {
  name: 'drop-down',
  data: function() {
    return {
      showingMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showingMenu = !this.showingMenu;
    },
    onClickOutside() {
      this.showingMenu = false;
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style lang="scss">
.drop-down {
  position: relative;
  display: inline;

  &--active {
    .drop-down__activator {
      color: color('primary') !important;
      background: color('background') !important;
    }
  }

  &__menu {
    min-width: 120px;
    background: white;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: absolute;
    top: calc(100% + 0.25rem);
    border: 1px solid color('grey', 'light');
    right: 0;
    z-index: 100;
    overflow: hidden;
  }
}
</style>
